import 'bootstrap/dist/css/bootstrap.css';
import 'ol/ol.css';
import 'ol-ext/dist/ol-ext.css';
import '@fortawesome/fontawesome-free/css/all.css';

import $ from "jquery";
import {Map, View} from 'ol';
import LayerTile from 'ol/layer/Tile';
import LayerImage from 'ol/layer/Image';
import SourceOSM from 'ol/source/OSM';
import ImageWMS from 'ol/source/ImageWMS';
import Projection from 'ol/proj/Projection';
import {Attribution, defaults as defaultControls} from 'ol/control';

import LayerSwitcher from 'ol-ext/control/LayerSwitcher';
import Overlay from 'ol-ext/control/Overlay';
import Toggle from 'ol-ext/control/Toggle';
import LayerGroup from 'ol/layer/Group';

//import ZeroMd from 'zero-md';
//customElements.define('zero-md', ZeroMd)

const config = require("./config/config.json");


const project_extent = JSON.parse(config.project_extent);
const project_center = JSON.parse(config.project_center);
const project_name = config.project_name;

//import { WindLayer } from 'ol-wind';

let initPage = function () {
  document.title = config.page_title;
  document.getElementById("page_header").textContent = config.page_header;
};

const projection = new Projection({
  code: 'EPSG:3857',
  units: 'm',
});

let attribution = new Attribution({
  collapsible: true,
});

const osm = new LayerTile({
  title: 'OpenStreetMap',
  source: new SourceOSM(),
  baseLayer: false,
  displayInLayerSwitcher: true
});

// const windLayer = new WindLayer(res, {
//   forceRender: false,
//   windOptions: {
//     // colorScale: scale,
//     velocityScale: 1 / 20,
//     paths: 5000,
//     // eslint-disable-next-line no-unused-vars
//     colorScale: () => {
//       // console.log(m);
//       return '#ff473c';
//     },
//     width: 3,
//     // colorScale: scale,
//     generateParticleOption: false
//   },
//   // map: map,
//   // projection: 'EPSG:4326'
// });

const hillshade = new LayerImage({
  title: 'Hillshade',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'LAYERS': 'hillshade', 'SLD_VERSION': '1.1.0'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['© <a href="https://www.lgl-bw.de">Landesamt für Geoinformation und Landentwicklung Baden-Würtemberg (LGL)</a>']
  }),
});

const hillshade_planung = new LayerImage({
  title: 'Hillshade (Planung)',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: false,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'LAYERS': 'hillshade_planung', 'SLD_VERSION': '1.1.0'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['© <a href="https://www.lgl-bw.de">Landesamt für Geoinformation und Landentwicklung Baden-Würtemberg (LGL)</a>']
  }),
});

const hwgk = new LayerImage({
  title: 'HWGK-Gewässer (unendlich leistungsfähig)',
  extent: project_extent,
  displayInLayerSwitcher: false,
  visible: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'LAYERS': 'hwgk', 'SLD_VERSION': '1.1.0'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['© <a href="https://www.lgl-bw.de">Landesamt für Geoinformation und Landentwicklung Baden-Würtemberg (LGL)</a>']
  }),
});

const buildings = new LayerImage({
  title: 'Gebäude',
  extent: project_extent,
  displayInLayerSwitcher: false,
  visible: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'LAYERS': 'buildings', 'SLD_VERSION': '1.1.0'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['© <a href="https://www.lgl-bw.de">Landesamt für Geoinformation und Landentwicklung Baden-Würtemberg (LGL)</a>']
  }),
});

const ba_flurstuecke = new LayerImage({
  title: 'Flurstück',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'LAYERS': 'ba_flurstuecke', 'SLD_VERSION': '1.1.0'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['© <a href="https://www.lgl-bw.de">Landesamt für Geoinformation und Landentwicklung Baden-Würtemberg (LGL)</a>']
  }),
});

let updateLegend_building = function (resolution) {
  let legendContainer = document.getElementById('legend_container');
  let wmsSource = buildings.getSource();
  let params = wmsSource.getParams();
  let graphicUrl = wmsSource.getLegendUrl(resolution, params);

  if (!document.getElementById('legend_div_' + params.LAYERS.substring(0, 2))) {

    let legendDiv = document.createElement('div');
    legendDiv.id = 'legend_div_' + params.LAYERS.substring(0, 2);
    legendDiv.className = 'd-flex order-0 align-items-start flex-column img-fluid';

    let legendImage = document.createElement('img');
    legendImage.id = 'legend_img_' + params.LAYERS.substring(0, 2);

    legendImage.src = graphicUrl;

    legendDiv.innerText = '';
    legendDiv.appendChild(legendImage);

    legendContainer.appendChild(legendDiv);
  }
};

const fh_hq010 = new LayerImage({
  title: 'HQ010',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: false,
  baseLayer: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'fh_hq010'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  }),
});

const fh_hq100 = new LayerImage({
  title: 'HQ100',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: true,
  baseLayer: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'fh_hq100'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  }),
});

const fh_hqext = new LayerImage({
  title: 'HQExtrem',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: false,
  baseLayer: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'fh_hqext'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  }),
});

const fg_sel = new LayerImage({
  title: 'selten',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: false,
  baseLayer: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'fg_sel'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  }),
});

const fr_sel = new LayerImage({
  title: 'selten',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: false,
  baseLayer: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'fr_sel'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  }),
});

const fg_aus = new LayerImage({
  title: 'außergewöhnlich',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: true,
  baseLayer: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'fg_aus'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  }),
});

const fg_aus_planung = new LayerImage({
  title: 'außerg. (Planung)',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: false,
  baseLayer: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'fg_aus_planung'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  }),
});

const gf_aus = new LayerImage({
  title: 'außergewöhnlich',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: true,
  baseLayer: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'gf_aus'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  }),
});

const gf_ext = new LayerImage({
  title: 'extrem',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: false,
  baseLayer: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'gf_ext'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  }),
});

const gf_sel = new LayerImage({
  title: 'selten',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: false,
  baseLayer: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'gf_sel'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  }),
});

const fr_aus = new LayerImage({
  title: 'außergewöhnlich',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: true,
  baseLayer: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'fr_aus'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  }),
});

const fr_aus_planung = new LayerImage({
  title: 'außerg. (Planung)',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: false,
  baseLayer: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'fr_aus_planung'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  }),
});

const fg_ext = new LayerImage({
  title: 'extrem',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: false,
  baseLayer: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'fg_ext'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  }),
});

const fr_ext = new LayerImage({
  title: 'extrem',
  extent: project_extent,
  vdisplayInLayerSwitcher: true,
  visible: false,
  baseLayer: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'fr_ext'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  }),
});

const ut_sel = new LayerImage({
  title: 'selten',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: false,
  baseLayer: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'ut_sel'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  }),
});

const ut_aus_src = new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'ut_aus'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  });

const ut_aus = new LayerImage({
  title: 'außergewöhnlich',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: true,
  baseLayer: true,
  source: ut_aus_src
});

const ut_aus_planung = new LayerImage({
  title: 'außerg. (Planung)',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: false,
  baseLayer: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'ut_aus_planung'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  }),
});

let setLegends = function() {
  let params = null;
  map.getLayers().forEach(function(layer) {
    if(layer instanceof LayerGroup) {
      const groupVisibility = layer.getVisible();
      layer.getLayers().forEach(function(groupLayer) {
        params = groupLayer.getSource().getParams();
        if (typeof params !== 'undefined') {
          const regtest = /^[a-z]{2}_./;
          if (regtest.test(params.LAYERS)) {
            let resolution = map.getView().getResolution();
            let wmsSource = groupLayer.getSource();
            let params = wmsSource.getParams();
            let graphicUrl = wmsSource.getLegendUrl(resolution, params);
            let legendContainer = document.getElementById('legend_container');
            //var divElement = document.getElementById('legend_' + params.LAYERS.substr(0,2)).parentElement;
            //var img = document.getElementById('legend_' + params.LAYERS.substr(0,2));
            //var img = document.getElementById('legend_img_' + params.LAYERS.substr(0,2));
            let div = document.getElementById('legend_div_' + params.LAYERS.substr(0,2));

            if (groupVisibility && groupLayer.getVisible() && !div) {

              let legendDiv = document.createElement('div');
              legendDiv.id = 'legend_div_' + params.LAYERS.substr(0,2);
              legendDiv.className = 'd-flex align-items-center flex-column px-3';

              let legendImage = document.createElement('img');
              legendImage.id = 'legend_img_' + params.LAYERS.substr(0,2);

              legendImage.src = graphicUrl;

              legendDiv.innerText = layer.get('title');
              legendDiv.appendChild(legendImage);

              legendContainer.appendChild(legendDiv);
              //divElement.hidden = false;
              //img.src = graphicUrl;
            }
            if (!groupVisibility) {
              if (div) {
                div.remove();
              }
              // while (legendContainer.firstChild) {
              //   legendContainer.removeChild(legendContainer.firstChild)
              // }
              //legendContainer.removeChild(document.getElementById('legend_' + params.LAYERS.substr(0,2)));
              //divElement.hidden = true;
              //img.removeAttribute("src");
            }
          }
        }
      });
    }
    // we only have groupLayers
    // else if(layer instanceof ImageWMS) {
    //   }
  });

};

const ut_ext = new LayerImage({
  title: 'extrem',
  extent: project_extent,
  displayInLayerSwitcher: true,
  visible: false,
  baseLayer: true,
  source: new ImageWMS({
    url: 'https://mapserver.mapwebbing.eu/cgi-bin/mapserv?map=/srv/projects/' + project_name + '/demo.map',
    params: {'VERSION': '1.1.1', 'LAYERS': 'ut_ext'},
    projection: projection,
    ratio: 1,
    serverType: 'mapserver',
    attributions: ['<a href="https://www.itr-gmbh.de/">ITR GmbH</a>']
  }),
});

const basemaps = [
  osm,
  new LayerGroup({
    title: 'Hintergrund',
    visible: false,
    visID: 'b1',
    displayInLayerSwitcher: true,
    layers: [hillshade,ba_flurstuecke]
  }),
  // new LayerGroup({
  //   title: 'Flurstücke',
  //   visible: false,
  //   visID: 'ba_flurstuecke',
  //   displayInLayerSwitcher: true,
  //   layers: [ba_flurstuecke ]
  // }),
  new LayerGroup({
    title: 'Überflutungstiefen',
    openInLayerSwitcher: true,
    visID: 'ut',
    //layers: [ut_aus]
    layers: [ut_ext,ut_aus,ut_sel]
  }),
  new LayerGroup({
    title: 'Fließgeschwindigkeiten',
    visible: false,
    visID: 'fg',
    openInLayerSwitcher: true,
    //layers: [fg_aus]
    layers: [fg_ext,fg_aus,fg_sel]
  }),
  new LayerGroup({
    title: 'Fließrichtung',
    visible: false,
    visID: 'fr',
    openInLayerSwitcher: true,
    //layers: [fr_aus]
    layers: [fr_ext,fr_aus,fr_sel]
  }),
  new LayerGroup({
    title: 'Gefahrenpotenzial',
    visible: false,
    visID: 'gf',
    openInLayerSwitcher: true,
    //layers: [gf_aus]
    layers: [gf_ext,gf_aus,gf_sel]
  }),
  // new LayerGroup({
  //   title: 'Flusshochwasser',
  //   visible: false,
  //   visID: 'fh',
  //   openInLayerSwitcher: true,
  //   //layers: [fr_aus]
  //   layers: [fh_hqext,fh_hq100,fh_hq010]
  // }),
  // new LayerGroup({
  //   visible: true,
  //   visID: 'hwgk',
  //   displayInLayerSwitcher: false,
  //   layers: [hwgk]
  // }),
  new LayerGroup({
    visible: true,
    visID: 'buildings',
    displayInLayerSwitcher: false,
    layers: [buildings]
  })
];

const map = new Map({
  target: 'map',
  layers: basemaps,
  controls: defaultControls({attribution: false}).extend([attribution]),
  view: new View({
    center: project_center,
    zoom: 15,
    projection: projection
  })
});

map.on('singleclick', function (evt) {
  document.getElementById('info').innerHTML = '';
  const viewResolution = /** @type {number} */ (map.getView().getResolution());
  let layerlist = [];
  map.getLayers().forEach(function(layer) {
    if(layer instanceof LayerGroup) {
      const groupVisibility = layer.getVisible();
      layer.getLayers().forEach(function(groupLayer) {
        let params = groupLayer.getSource().getParams();
        if (typeof params !== 'undefined') {
          const regtest = /^[a-z]{2}_./;
          if (regtest.test(params.LAYERS)) {
            let wmsSource = groupLayer.getSource();
            let params = wmsSource.getParams();
            if (groupVisibility && groupLayer.getVisible()) {
              if (params.LAYERS.substring(0,2) === 'fg' || params.LAYERS.substring(0,2) === 'ut' || params.LAYERS.substring(0,2) === 'gf' || params.LAYERS.substring(0,2) === 'ba') {
                layerlist.push(params.LAYERS);
              }
            }
          }
        }
      });
    }
  });
  const url = ut_aus_src.getFeatureInfoUrl(
    evt.coordinate,
    viewResolution,
    'EPSG:3857',
    {'INFO_FORMAT': 'text/html', 'FEATURE_COUNT': 1, 'QUERY_LAYERS': layerlist.join(",")}
  );
  if (url && layerlist.length > 0) {
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        document.getElementById('info').innerHTML = html;
      });
  }
  else {
    document.getElementById('info').innerHTML = 'Keine Abfrageergebnisse verfügbar';
  }
});

initPage();
updateLegend_building();
setLegends();


// map.getView().on('change:resolution', function (event) {
//   var resolution = event.target.getResolution();
//   //updateLegend(resolution);
// });

const layerSwitcher = new LayerSwitcher({
  show_progress: false,
  trash: false,
  collapsed: false,
  reordering: false
});
map.addControl(layerSwitcher);

layerSwitcher.on('drawlist', (e) => {
  let layer = e.layer;
  e.li.querySelector('label').addEventListener('click', () => {
    setLegends();
  });
});

let menu = new Overlay ({
  closeBox : true,
  className: "slide-left menu",
  content: $("#menu").get(0)
});
map.addControl(menu);

let t = new Toggle(
  {	html: '<i class="fa fa-question fa-lg" ></i>',
    className: "menu",
    title: "Beschreibung",
    onToggle: function() { menu.toggle(); }
  });
map.addControl(t);
